module.exports = __webpack_public_path__ + "static/img/IOS客户端软件.8ff6ca6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cert/IOS客户端软件.jpg
// module id = Oedn
// module chunks = 15